export const sortListProfileTypes = [
  {
    value: 'GUIDE',
    title: 'Гид'
  },
  {
    value: 'ORGANIZATION',
    title: 'Организация культуры'
  },
  {
    value: 'TOURIST_AGENCY',
    title: 'Тур. оператор.агенство'
  },
  {
    value: 'EVENT_ORGANIZER',
    title: 'Организатор мероприятия'
  }
]
export const listProfileTypes = [
  {
    name: 'page-guide',
    value: 'GUIDE',
    text: 'Гид'
  },
  {
    name: 'page-cultural-organization',
    value: 'ORGANIZATION',
    text: 'Организация культуры'
  },
  {
    name: 'page-tourist-agency',
    value: 'TOURIST_AGENCY',
    text: 'Тур. оператор.агенство'
  },
  {
    name: 'page-event-organizer',
    value: 'EVENT_ORGANIZER',
    text: 'Организатор мероприятия'
  },
  {
    name: 'page-hotel',
    value: 'HOTEL',
    text: 'Отель'
  }
]
